var _circle, _defs, _clipPath, _circle2, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallBluePlanet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "48.383px",
    viewBox: "0 0 80 48.383",
    enableBackground: "new 0 0 80 48.383",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.104,
    y1: 8.1611,
    x2: 60.8034,
    y2: 45.4297
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0081,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_1_)",
    cx: 40.459,
    cy: 24.191,
    r: 24.192
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_2_",
    cx: 40.643,
    cy: 24.191,
    r: 19.518
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.2549,
    y1: 11.2588,
    x2: 57.0572,
    y2: 41.3272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#61C6F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    style: {
      stopColor: "#58BBEB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4572,
    style: {
      stopColor: "#409FDA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    style: {
      stopColor: "#1971BE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8936,
    style: {
      stopColor: "#1269B9"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_3_)",
    fill: "url(#SVGID_4_)",
    cx: 40.643,
    cy: 24.191,
    r: 19.518
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53,
    clipPath: "url(#SVGID_3_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5A9CD4",
    d: "M47.543,4.06c0.84,3.336-0.586,7.124-3.418,9.078c-2.178,1.504-5.057,2.001-6.814,3.982 c-1.286,1.451-1.73,3.445-2.086,5.351c-0.356,1.907-0.702,3.899-1.855,5.458c-1.154,1.559-3.397,2.506-5.089,1.557 c-1.447-0.813-1.965-2.653-2-4.313s0.27-3.348-0.111-4.963c-0.284-1.203-0.932-2.281-1.521-3.367 c-0.59-1.085-1.142-2.238-1.204-3.472c-0.127-2.501,1.044-4.38,3.131-5.668c1.763-1.087,4.251-2.454,6.193-3.011 C32.364,5.697,31.58,6.5,31.372,7.632c-0.208,1.135,0.223,2.475,1.276,2.944c0.831,0.369,1.804,0.118,2.632-0.257 c2.622-1.191,4.635-3.648,5.285-6.455L47.543,4.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A9CD4",
    d: "M49.836,9.017c-0.803,1.394-1.107,3.021-1.518,4.584s-0.982,3.167-2.156,4.245 c-1.295,1.188-3.104,1.547-4.633,2.388c-1.626,0.894-3.159,2.976-3.412,7.313c-0.182,3.119,2.914,5.341,5.701,4.101 c7.262-3.234,16.727-10.91,13.234-22.252C56.016,6.026,51.959,5.328,49.836,9.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A9CD4",
    d: "M19.358,18.732c1.285-0.5,2.152,0.01,2.761,1.248c0.609,1.238,0.589,2.677,0.612,4.056 c0.072,4.396,1.58,8.738,5.808,10.75c2.918,1.388,6.039,2.239,9.283,2.314c9.375,0.22,20.422-7.427,21.569-17.167 c0.086-0.727,0.346-2.007,0.076-2.702c2.107,5.409,2.604,9.169,0.057,14.387c-1.049,2.146-2.643,3.998-4.643,5.305 c-13.869,9.055-25.639,3.911-28.56,1.749c-2.921-2.163-4.513-5.454-5.776-8.862C19.281,26.401,18.805,22.451,19.358,18.732z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.5991,
    y1: -20.8809,
    x2: 133.0935,
    y2: -9.1099,
    gradientTransform: "matrix(1.0867 -0.0677 0.0734 1.1791 -104.3326 43.9815)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "url(#SVGID_5_)",
    d: "M44.999,10.343c-2.305-2.963-8.122-1.767-12.99,2.672s-6.946,10.44-4.641,13.403 c2.306,2.963,8.122,1.768,12.99-2.672C45.227,19.307,47.305,13.306,44.999,10.343z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M46.106,5.455c5.873,3.364,9.834,9.689,9.834,16.943c0,10.779-8.738,19.517-19.517,19.517 c-1.897,0-3.729-0.276-5.464-0.78c2.854,1.635,6.158,2.574,9.684,2.574c10.779,0,19.518-8.738,19.518-19.518 C60.161,15.31,54.225,7.818,46.106,5.455z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M59.831,28.172c5.344-0.575,8.67-1.381,8.67-2.273c0-0.869-3.162-1.658-8.275-2.23 c0.004,0.161,0.025,0.318,0.025,0.48C60.25,25.529,60.102,26.873,59.831,28.172z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.282,23.512c-5.991,0.581-9.782,1.434-9.782,2.386c0,0.976,3.971,1.848,10.21,2.429 c-0.294-1.348-0.46-2.743-0.46-4.178C21.25,23.934,21.275,23.726,21.282,23.512z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.282,23.512c-0.007,0.213-0.032,0.422-0.032,0.637c0,1.435,0.166,2.831,0.46,4.178 c4.95,0.46,11.327,0.738,18.29,0.738c7.709,0,14.7-0.341,19.831-0.894c0.271-1.299,0.42-2.643,0.42-4.023 c0-0.162-0.021-0.319-0.025-0.48C55.063,23.09,47.909,22.732,40,22.732C32.833,22.732,26.29,23.027,21.282,23.512z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22.511,30.996c2.774,7.387,9.883,12.652,18.24,12.652c8.398,0,15.535-5.318,18.279-12.764 c-5.658,0.434-12.141,0.681-19.03,0.681C33.728,31.565,27.794,31.361,22.511,30.996z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M59.971,20.99C58.459,11.726,50.442,4.649,40.75,4.649c-9.651,0-17.643,7.017-19.204,16.223 c5.522-0.408,11.795-0.639,18.453-0.639C47.276,20.232,54.092,20.509,59.971,20.99z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 26.2183,
    x2: 80.0005,
    y2: 26.2183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEE62A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1378,
    style: {
      stopColor: "#FDD82B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3964,
    style: {
      stopColor: "#F9B42C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7453,
    style: {
      stopColor: "#F37B2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9911,
    style: {
      stopColor: "#EF4E31"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M59.971,20.99c0.143,0.875,0.232,1.768,0.254,2.679c5.113,0.572,8.275,1.361,8.275,2.23 c0,0.893-3.326,1.698-8.67,2.273C54.7,28.725,47.709,29.065,40,29.065c-6.963,0-13.34-0.278-18.29-0.738 c-6.239-0.581-10.21-1.453-10.21-2.429c0-0.952,3.791-1.806,9.782-2.386c0.029-0.897,0.118-1.778,0.265-2.641 C8.746,21.816,0,23.712,0,25.898c0,2.242,9.185,4.178,22.511,5.098c5.283,0.365,11.217,0.569,17.489,0.569 c6.889,0,13.372-0.247,19.03-0.681C71.518,29.926,80,28.053,80,25.898C80,23.8,71.94,21.969,59.971,20.99z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBluePlanet);
export default __webpack_public_path__ + "static/media/small-blue-planet.5c6f6b367813297e9cfdd01cf7d6aecf.svg";
export { ForwardRef as ReactComponent };